// M13.3 — device-mix palette + canonical render order, extracted from
// MobileChart.tsx so React Fast Refresh stays happy (the chart file now
// only exports components).
//
// Mirrors src/shared/report/device-mix-svg.ts so the dashboard, PDF, and
// shared viewer tell the same visual story:
//   Desktop = blurple-700 (#0E1680) — anchor blurple
//   Mobile  = pink-500    (#EC4899) — the M12 marketing CTA family
//   Tablet  = gray-400    (#9CA3AF)
//   Other   = gray-200    (#E5E7EB) — quiet, lives behind the named devices

export type DeviceKey = "desktop" | "mobile" | "tablet" | "other";

export const DEVICE_COLOR: Record<DeviceKey, string> = {
  desktop: "#0E1680",
  mobile: "#EC4899",
  tablet: "#9CA3AF",
  other: "#E5E7EB",
};

export const DEVICE_LABEL: Record<DeviceKey, string> = {
  desktop: "Desktop",
  mobile: "Mobile",
  tablet: "Tablet",
  other: "Other",
};

// Canonical render order — same one the shared/PDF builder uses so the
// donut, stacked area, legend, and PDF page all read in the same order
// regardless of which device happens to dominate on a given property.
export const DEVICE_RENDER_ORDER: ReadonlyArray<DeviceKey> = [
  "desktop",
  "mobile",
  "tablet",
  "other",
];
